module.exports = __webpack_public_path__ + "assets/img/case3.e096fee3.png";